import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function RoleSetOption ( props ) {

    return <BasicCrudScreenType id="RoleSetOption" table="RoleSetOption" view="VwRoleSetOption" />;

}

export default RoleSetOption;
